import { Button } from '@design-system/button';
import { navigate } from 'gatsby';
import React, { FC } from 'react';

import CartItemWrapper from '~/components/ShoppingCart/CartItemWrapper';

import { ProductsListProps } from './models';

const ProductsList: FC<ProductsListProps> = ({
  productCartItemSettings,
  continueShoppingButton,
  handleRemoveItem,
  products,
}) => (
  <div className="shopping-cart__products">
    {products?.map(({ id, title, quantity, variant, customAttributes }) => (
      <CartItemWrapper
        key={id.toString()}
        id={id}
        title={title}
        productVariant={variant}
        quantity={quantity}
        productCartItemSettings={productCartItemSettings}
        customAttributes={customAttributes}
        handleRemoveItem={handleRemoveItem}
      />
    ))}
    <Button
      {...continueShoppingButton}
      className="shopping-cart__continue-button"
      onClick={() => navigate(continueShoppingButton.link)}
    />
  </div>
);

export default ProductsList;
